import React, { useEffect, useState } from "react";
import cookies from "react-cookies";
import { homeUrl } from "../../shared/utils/apiEndPoints";
import moment from "moment";
import "moment/locale/id";
import { useLocation, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as RoutePath from "../../shared/utils/routeLink";
// import * as Variable from "../../shared/utils/variables";
import * as ActionTypes from "../../store/actions/actionTypes";
// import * as USERROLES from "../../shared/utils/userroles";
import "./MainComponent.scss";
// import { toast } from "react-toastify";
import LoadingComponent from "../../shared/component/LoadingComponent/LoadingComponent";
import Header from "../Header/Header";
import FooterComponent from "../FooterComponent/FooterComponent";
import HomeComponent from "../../component/HomeComponent/HomeComponent";
import SecondaryHeader from "../Header/SecondaryHeader";
import LogStatusHandler from "./LogStatusHandler";
import CreateAccount from "../../component/CreateAccount/CreateAccount";
import CollegeListing from "../../component/ListingComponents/CollegeListing";
import MajorListing from "../../component/ListingComponents/MajorListing";
import CareerListing from "../../component/ListingComponents/CareerListing";
import ScholarshipListing from "../../component/ListingComponents/ScholarshipListing";
import LoginModal from "../../shared/component/LoginModal/LoginModal";
import ProfileDetail from "../../component/ProfileDetail/ProfileDetail";
import CollegeDetail from "../../component/CollegeDetail/CollegeDetail";
import MajorDetail from "../../component/MajorDetail/MajorDetail";
import CareerDetail from "../../component/CareerDetail/CareerDetail";
import ScholarshipDetail from "../../component/ScholarshipDetail/ScholarshipDetail";
import Favorite from "../../component/Favorite/Favorite";
import ForgotPassword from "../../component/ForgotPassword/ForgotPassword";
import { Helmet } from "react-helmet";
import { CaretDown } from "../../shared/component/svg/Icons";
import { SCROLL_TO_TOP } from "../../shared/utils/variables";

// This function will return the Component on any given address
const getActiveComp = (name) => {
	// Do this if you have an id
	if (name && name.includes(RoutePath.COLLEGE_DETAIL)) {
		name = RoutePath.COLLEGE_DETAIL;
	}
	if (name && name.includes(RoutePath.MAJOR_DETAIL)) {
		name = RoutePath.MAJOR_DETAIL;
	}
	if (name && name.includes(RoutePath.CAREER_DETAIL)) {
		name = RoutePath.CAREER_DETAIL;
	}
	if (name && name.includes(RoutePath.SCHOLARSHIP_DETAIL)) {
		name = RoutePath.SCHOLARSHIP_DETAIL;
	}
	if (name && name.includes(RoutePath.FAVORITE)) {
		name = RoutePath.FAVORITE;
	}
	switch (name) {
		case RoutePath.ROOT: {
			return {
				activeComponent: HomeComponent,
				isActiveComponent: RoutePath.ROOT,
				hideSecondaryHeader: true,
			};
		}
		case RoutePath.CREATE_ACCOUNT: {
			return {
				activeComponent: CreateAccount,
				isActiveComponent: RoutePath.CREATE_ACCOUNT,
				hideHeader: true,
				hideSecondaryHeader: true,
			};
		}
		case RoutePath.FORGOT_PASSWORD: {
			return {
				activeComponent: ForgotPassword,
				isActiveComponent: RoutePath.FORGOT_PASSWORD,
				hideHeader: true,
				hideSecondaryHeader: true,
			};
		}
		case RoutePath.PROFILE: {
			return {
				activeComponent: ProfileDetail,
				isActiveComponent: RoutePath.PROFILE,
				hideHeader: true,
				hideSecondaryHeader: true,
			};
		}
		case RoutePath.COLLEGE: {
			return {
				activeComponent: CollegeListing,
				isActiveComponent: RoutePath.COLLEGE,
			};
		}
		case RoutePath.MAJOR: {
			return {
				activeComponent: MajorListing,
				isActiveComponent: RoutePath.MAJOR,
			};
		}
		case RoutePath.CAREER: {
			return {
				activeComponent: CareerListing,
				isActiveComponent: RoutePath.CAREER,
			};
		}
		case RoutePath.SCHOLARSHIP: {
			return {
				activeComponent: ScholarshipListing,
				isActiveComponent: RoutePath.SCHOLARSHIP,
			};
		}
		case RoutePath.COLLEGE_DETAIL: {
			return {
				activeComponent: CollegeDetail,
				isActiveComponent: RoutePath.COLLEGE_DETAIL,
			};
		}
		case RoutePath.MAJOR_DETAIL: {
			return {
				activeComponent: MajorDetail,
				isActiveComponent: RoutePath.MAJOR_DETAIL,
			};
		}
		case RoutePath.CAREER_DETAIL: {
			return {
				activeComponent: CareerDetail,
				isActiveComponent: RoutePath.CAREER_DETAIL,
			};
		}
		case RoutePath.SCHOLARSHIP_DETAIL: {
			return {
				activeComponent: ScholarshipDetail,
				isActiveComponent: RoutePath.SCHOLARSHIP_DETAIL,
			};
		}
		case RoutePath.FAVORITE: {
			return {
				activeComponent: Favorite,
				isActiveComponent: RoutePath.FAVORITE,
			};
		}

		default: {
			return { activeComponent: LoadingComponent, isActiveComponent: name };
		}
	}
};

const MainComponent = ({ ENV_NAME, ...props }) => {
	let location = useLocation();
	const [component, setComponent] = useState({
		activeComponent: LoadingComponent,
		isActiveComponent: "",
	});
	const [showScrollButton, setShowScrollButton] = useState(false);

	// We remove console log functionality in production
	useEffect(() => {
		const handleScrollButtonVisibility = () => {
			setShowScrollButton(window.scrollY > window.screen.height * 0.5);
		};

		if (homeUrl === "portalsekolah.co.id") {
			console.log = function () {};
		}
		window.addEventListener("scroll", handleScrollButtonVisibility);

		return () => {
			window.removeEventListener("scroll", handleScrollButtonVisibility);
		};
	}, []);

	// For every link change, we set the component according to the page
	useEffect(() => {
		let component = getActiveComp(location.pathname);
		setComponent(component);
		window.scrollTo({ top: 0, left: 0, behavior: "instant" });
	}, [location]);

	// I don't really know what's the best way to detect the cookie change
	// But for every cookie change, we set our language prefs aswell
	useEffect(() => {
		let lang = cookies.load("lang");
		if (lang !== ENV_NAME) {
			props.changeLanguage(lang);
			if (lang !== "eng") {
				moment.locale("id");
				moment.updateLocale("id", {
					longDateFormat: {
						LT: "HH:mm",
						LTS: "HH:mm:ss",
						L: "DD/MM/YYYY",
						LL: "D MMMM YYYY",
						LLL: "D MMMM YYYY [pukul] HH:mm",
						LLLL: "dddd, D MMMM YYYY [pukul] HH:mm",
					},
				});
			} else moment.locale("en");
		}
	});

	return (
		<>
			<Helmet>
				<title>Direktori Kampus Terbaik di Indonesia - Portal Sekolah</title>
			</Helmet>
			{/* This is to check the login status of a user */}
			<LogStatusHandler />

			{/* 
				Sticky navbar, notice that it can be hidden in some pages if necessary
				by changing the showHeader key in getActiveComp 
			*/}
			{!component.hideHeader && <Header />}
			{!component.hideSecondaryHeader && <SecondaryHeader />}

			<button
				className={`btn btn-primary btn-scrollTop ${showScrollButton ? "" : "hide"}`}
				onClick={() => {
					window.scrollTo({
						top: 0,
						behavior: "smooth",
					});
				}}
				title={SCROLL_TO_TOP[ENV_NAME]}
			>
				<CaretDown stroke="white" className="caret-top" />
			</button>

			<LoginModal show={props.loginModalShow} onHide={() => props.setLoginModalShow(false)} />
			{/* Active component based on the page */}
			<component.activeComponent />

			{!component.hideFooter && <FooterComponent />}
		</>
	);
};

const mapStateToProps = (state) => {
	return { ...state, loginModalShow: state.auth.loginModalShow, ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};

const mapStateToDispatch = (dispatch) => {
	return {
		changeLanguage: (payload) =>
			dispatch({
				type: ActionTypes.UPDATE_LANGUAGE,
				payload: payload,
			}),
		setLoginModalShow: (payload = true) => {
			if (payload) {
				dispatch({
					type: ActionTypes.OPEN_LOGIN_MODAL,
				});
			} else {
				dispatch({
					type: ActionTypes.CLOSE_LOGIN_MODAL,
				});
			}
		},
	};
};

export default connect(mapStateToProps, mapStateToDispatch)(withRouter(MainComponent));
